/**
 * One address, formatted one way, for every surface that shows one.
 *
 * This lived as a module-local helper inside `EventDetailPopup.jsx` and was not
 * exported, so the Tasks console's "Avail. Sooner" rows — which show the same
 * customer's address and offer a copy button for it — had no way to reach it.
 * Two copies of a join is how "3151 Split Rick Circle, Bulverde, Texas, 78163"
 * becomes "3151 Split Rick Circle Bulverde TX 78163" on the next screen.
 *
 * Takes the CUSTOMER, not a schedule row: the popup has a row and the panel
 * has a customer, and the row is the caller's business, not the formatter's.
 *
 * `filter(Boolean)` drops missing parts rather than leaving ", ," gaps — a
 * client with no zip on file is common and should not render punctuation.
 */
export const formatCustomerAddress = (customer) => {
  if (!customer) return "";

  return [
    customer.streetAddress,
    customer.city,
    customer.state,
    customer.zipCode,
  ]
    .filter(Boolean)
    .join(", ");
};

export default formatCustomerAddress;
